import { z } from 'zod';

export type ModelDeliveryPriceStatus = {
    model_id: number,
    exist_delivery: boolean,
};

export const ModelsDeliveryPricesStatusesSchema = z.object({
    model_id: z.number(),
    exist_delivery: z.boolean(),
}).array();
